import * as React from "react";
import { SVGProps } from "react";
const SvgCheckboxCheckedInverted = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#checkbox-checked-inverted_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0c3.608 0 7.215.343 10.822 1.03a5.212 5.212 0 0 1 4.149 4.148 57.381 57.381 0 0 1 0 21.644 5.212 5.212 0 0 1-4.15 4.15A57.781 57.781 0 0 1 16.002 32 57.8 57.8 0 0 1 5.18 30.971a5.215 5.215 0 0 1-4.15-4.149 57.408 57.408 0 0 1 0-21.644A5.214 5.214 0 0 1 5.18 1.03 57.786 57.786 0 0 1 16 0Zm8.498 8.353a1 1 0 0 0-.84.333l-.073.094-8.876 12.477-6.535-4.647a1 1 0 0 0-1.258 1.55l.098.08 7.35 5.227c.14.1.299.158.459.178l.12.007.12-.007a1 1 0 0 0 .62-.32l.076-.093L25.214 9.94a1 1 0 0 0-.716-1.587Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="checkbox-checked-inverted_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckboxCheckedInverted;
